import { render, staticRenderFns } from "./AgendaMenu.vue?vue&type=template&id=4f7c46a7&"
import script from "./AgendaMenu.vue?vue&type=script&lang=ts&"
export * from "./AgendaMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports